// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/index.css */
/* Tesla browser changed DPI - render whole page at 75% */
html {
  zoom: 0.75;
  background: #000;
}
body {
  background: #000;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB,yDAAyD;AACzD;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["/* src/index.css */\n/* Tesla browser changed DPI - render whole page at 75% */\nhtml {\n  zoom: 0.75;\n  background: #000;\n}\nbody {\n  background: #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
